import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  exchangeCountFromModel,
  validateExchangeCountCondition,
  type ExchangeCountState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const EXCHANGE_COUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ExchangeCountState>>,
): ConditionType<ExchangeCountState, Condition.ExchangeCount> => ({
  name: CONDITION_NAMES[Condition.EXCHANGE_COUNT],
  description(state) {
    if (state === undefined) {
      return t("Number of previous exchanges less than");
    }
    return t("Number of previous exchanges less than {{value}}", {
      value: state,
    });
  },
  Details(props: ConditionTypeDetailsProps<ExchangeCountState>) {
    return React.createElement(Details, props);
  },
  empty: (1).toFixed(0),
  fromModel(model) {
    return exchangeCountFromModel(model);
  },
  toModel(state) {
    return { type: Condition.EXCHANGE_COUNT, numExchanges: +state };
  },
  valid(state) {
    return validateExchangeCountCondition(state).valid;
  },
});
